import CaseStudiesShow from './CaseStudiesShow';

export default CaseStudiesShow;
